(function () {
    'use strict';

    angular
        .module('planInitiativeModule')
        .directive('grcPlanInitiative', directive);

    directive.$inject = ['boxTmplScope', 'boxTmplHtml', 'boxTmplLinkFn'];

    function directive(boxTmplScope, boxTmplHtml, boxTmplLinkFn) {

        var directiveScope         = _.clone(boxTmplScope);
        directiveScope.layoutRatio = '=?';
        directiveScope.highlight = '=';
        directiveScope.showCreationStatus = '@';

        return {
            scope: directiveScope,
            template: boxTmplHtml,
            controller: ['$rootScope', '$scope', '$modal', '$state', '$controller', 'businessPlanningService', function ($rootScope, $scope, $modal, $state, $controller, businessPlanningService) {

                 /**
                  * @property {{
                  *         PlanBusinessUnitInvolvedList,
                  *         PlanBusinessUnitOwnerList,
                  *         InitiativeCode,
                  *         PlanCorporateObjective,
                  *         PlanCorporateObjective.PlanAxe,
                  *         PlanCorporateObjective.PlanElement,
                  *         OwnerDelegate
                  *     }} boxModel
                  */

                // Box Template
                $scope.baseTemplatePath = '/app/shared/grc/businessPlanning/initiative/grcPlanInitiative.[Template].tpl.html';
                // Permissions default values
                $scope.boxFeatureRole   = $scope.boxFeatureRole || 'GRCBusinessPlanningManagement';
                $scope.boxPermissionKey = $scope.boxPermissionKey || 'PlanInitiative';

                $controller('BoxTmplController', {$scope: $scope});

                $scope.ctxt = {};

                var unwatch = $scope.$watch('ctxt.form', function (newVal) {
                    if (newVal) {
                        $scope.ctxt.form.$setValidity('RequiredOwnerDelegate', false);
                        unwatch();
                    }
                });
                $scope.ctxtDir = {
                    selectionService: _.get($scope, 'boxContext.selectionService')
                };

                $scope.readOnly = !$scope.boxPermissions.Edit;

                // Selection
                $scope.selection = {
                    showCheckbox: false,
                    selected: false
                };

                if ($scope.boxContext && $scope.boxContext.selectionService) {
                    $scope.selection.selected = _.findIndex($scope.boxContext.selectionService.selectedItems,
                        {PlanInitiativeID: $scope.boxModel.PlanInitiativeID}) > -1;
                }

                $scope.$watchCollection('boxContext.selectionService.selectedItems', function (/*undefined|Array*/ newVal) {
                    if (newVal) {
                        $scope.selection.selected = newVal.indexOf($scope.boxModel.PlanInitiativeID) > -1;
                    }
                });

                // Layout
                $scope.getPlanInitiativeColumn = function () {
                    var defaultPlanInitiativeColumn = 'col-sm-12';

                    if (_.isUndefined($scope.layoutRatio)) return defaultPlanInitiativeColumn;
                    if (_.isUndefined($scope.layoutRatio.planInitiativeColumn)) return defaultPlanInitiativeColumn;

                    return $scope.layoutRatio.planInitiativeColumn;
                };

                $scope.getBoxClass = function () {
                    var defaultBoxType = 'is-nav',
                        clickable      = '';

                    if (!$scope.isBoxClickable) {
                        clickable = ' not-clickable-card';
                    }

                    if (_.isUndefined($scope.layoutRatio)) return defaultBoxType + clickable;
                    if (_.isUndefined($scope.layoutRatio.boxType)) return defaultBoxType + clickable;

                    return $scope.layoutRatio.boxType + clickable;
                };

                // Page is dirty
                $scope.ctxtDir.needSaveChanges = false;

                $scope.pageIsDirty = function () {
                    $scope.ctxtDir.needSaveChanges = true;
                    $rootScope.$broadcast('page-is-dirty');
                };

                $scope.pageIsNotDirty = function () {
                    $scope.ctxtDir.needSaveChanges = false;
                    $rootScope.$broadcast('page-is-not-dirty');
                };

                $scope.selectionChanged = function () {
                    $scope.boxContext.selectionService.itemSelectionChanged($scope.boxModel, $scope.selection.selected);
                };

                $scope.clickedOnCheckbox = function ($event) {
                    // Prevent clicking on the box
                    $event.stopPropagation();
                }
            }],

            link: function (scope, elem, attrs) {
                boxTmplLinkFn(scope, elem, attrs);
            }
        }
    }
})();